import {connect} from 'react-redux';
import PageView from '../components/views/PageView';
import * as LoginActions from '../actions/LoginActions';
import * as UIActions from '../actions/UIActions';
import * as UTMActions from '../actions/UTMActions';
import {isEmpty} from '../../common/utils/ValidationUtils';
import {CURRENT_CHECKED, LEVEL, STEPS_GRAPH_CMS} from '../constants/StepConstants';
import {MODAL_TYPE} from '../constants/ModalConstants';
import * as ModalActions from '../actions/ModalActions';
import {APP_WEB} from '../constants/GlobalConstants';

const mapStateToProps = (state, {app = APP_WEB}) => {
    const ui = state.creditoReal.ui;
    return {
        app,
        isLoggedIn: !isEmpty(state.profile.accessToken),
        steps: state.ui.stepView.steps,
        stepsWizard: state.catalogs.headlessGraphCms.wizard,
        mainStep: state.ui.stepView.mainStep,
        highestStep: state.creditoReal.loanApplication.highestStep,
        country: state.countrySelector.countrySelected,
        levelSelected: state.catalogs.headlessGraphCms.levelSelected,
        bureauAlreadyValidated: ui.bureauAskForNipView.bureauAlreadyValidated
    };
};

const mapDispatchToProps = dispatch => ({
    goToLoginAndRedirect: (url) => {
        dispatch(LoginActions.LOGIN_AND_REDIRECT_ACTION.action(url));
    },
    onPressStep: (step, highestStep) => () =>
        dispatch(UIActions.ON_SELECT_STEP_ACTION.action(step, highestStep, true)),
    onLoad: (step, highestStep) =>
        dispatch(UIActions.ON_SELECT_STEP_ACTION.action(step, highestStep)),
    onPressBackStep: highestStep => idStepBack =>
        dispatch(UIActions.ON_SELECT_STEP_ACTION.action(idStepBack, highestStep, true)),
    onPressLogout: () =>
        dispatch(LoginActions.LOGOUT_ACTION.action()),
    onUTMData: (url) => {
        dispatch(UTMActions.GET_UTM_URL_ACTION.action(url));
        dispatch(UTMActions.GET_PARAMS_URL_ACTION.action(url));
    },
    onPressModalAssistant: (assistantInformation) => {
        const content = {
            type: MODAL_TYPE.ASSISTANT_INFORMATION_VIEW,
            data: {
                assistantInformation
            }
        };
        const options = {
            closeOnOverlayClick: false,
            size: 'small'
        };
        dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options));
    }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const stepSelected = stateProps.steps.find(item => item.selected === CURRENT_CHECKED);
    const stepNameSelected = stepSelected ? stepSelected.name : '';
    const stepPercentageSelected = stepSelected ? stepSelected.percentage : 0;
    const stepIdSelected = stepSelected ? stepSelected.id : 0;
    const stepsWizard = stateProps.steps.find(item => item.id === ownProps.step);
    const bureauValidated = !!stepsWizard && stepsWizard.stepId === STEPS_GRAPH_CMS.STEP_STEP_4  &&
        stateProps.bureauAlreadyValidated && LEVEL.LEVEL_1;
    const stepIdGraphCMS = ownProps.graphId ? ownProps.graphId : !!stepsWizard && stepsWizard.stepId;
    const mapperStepWizard = stateProps.stepsWizard.find(wizardMx =>
            wizardMx.step === stepIdGraphCMS);
    const levelSelected = bureauValidated || ownProps.level || LEVEL.LEVEL_0;
    const assistantInformation = !!mapperStepWizard ? mapperStepWizard.informationMxes.find(informationMx =>
        informationMx.level === levelSelected
    ) : null;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        stepNameSelected,
        stepPercentageSelected,
        stepIdSelected,
        assistantInformation,
        step: ownProps.step || "1",
        steps: stateProps.steps.map(item => ({
            ...item,
            onPress: dispatchProps.onPressStep(item.id, stateProps.highestStep)
        })),
        onPressBackStep: dispatchProps.onPressBackStep(stateProps.highestStep)
    };
};

const PageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PageView);

export default PageContainer;
